export default ({ user: { data } }) => data;



// WEBPACK FOOTER //
// ./src/store/mappers/user.js